export default __webpack_public_path__ + "static/media/logos.3cbcacc8.png";